// Utils
import { prop } from '../../../utils/immutableHelper';
import { asNum, getX, getY } from '../dimensionUtil';
import { Rect } from './rectTypes';

// Rectangle property accessors
export const getLeft = getX;
export const getTop = getY;
export const getRight = (rect: Partial<Rect>): number =>
    asNum(prop('right', rect) || getLeft(rect) + prop('width', rect));
export const getBottom = (rect: Partial<Rect>): number =>
    asNum(prop('bottom', rect) || getTop(rect) + prop('height', rect));

export const getWidth = (rect: Partial<Rect>): number => asNum(prop('width', rect) || getRight(rect) - getLeft(rect));
export const getHeight = (rect: Partial<Rect>): number => asNum(prop('height', rect) || getBottom(rect) - getTop(rect));

// Rectangle constructor
export const asRect = (rect: Partial<Rect>): Rect => {
    const x = getX(rect);
    const y = getY(rect);

    return {
        x,
        y,
        top: y,
        right: getRight(rect),
        bottom: getBottom(rect),
        left: x,
        width: getWidth(rect),
        height: getHeight(rect),
    };
};
